module.exports = __webpack_public_path__ + "static/media/observer.4128d750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/commanders/observer.png
// module id = 2065
// module chunks = 0